module.exports = __webpack_public_path__ + "images/assets/a333ef994d0c9addf42de0580d5b5191.svg";